import script from "./Deduction.vue?vue&type=script&setup=true&lang=js"
export * from "./Deduction.vue?vue&type=script&setup=true&lang=js"

import "./Deduction.vue?vue&type=style&index=0&id=5e75fab4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e75fab4"]])

export default __exports__